/** Mirrors the API's `DeclineContext` (apps/gfgf-api/src/interfaces/decline.ts). */
export interface DeclineContext {
  senderName: string | null;
  recipientFirstName: string | null;
  /** Already declined: show the confirmation, never the form again. */
  alreadyDeclined: boolean;
  /** False when the gift ended some other way (taken, cancelled, expired). */
  open: boolean;
}

/**
 * The four fixed reasons, verbatim from v1's decline page. The chosen sentence is what the API
 * stores in `contacts.decline_reason`, so these strings must match `dto/decline.ts` exactly —
 * a reworded option here would be rejected by the DTO's enum.
 */
export const DECLINE_REASONS = [
  "My company policy does not allow me to accept gifts.",
  "I would prefer to donate the gift value.",
  "I do not need a gift at this time.",
  "I do not know the sender or company who sent me this gift.",
] as const;

export type DeclineReason = (typeof DECLINE_REASONS)[number] | "other";

export interface DeclineGiftBody {
  reason: DeclineReason;
  reasonText?: string;
}
